import React, { Fragment } from "react";
import CooperativesDetailSalariesTable from "containers/cooperativesDetailSalariesTable";
export default function() {
  return (
    <Fragment>
      <CooperativesDetailSalariesTable />
    </Fragment>
  );
}